import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './logos1.css'

const Logos1 = (props) => {
  return (
    <div
      className={`logos1-container1 thq-section-padding ${props.rootClassName} `}
    >
      <div className="logos1-max-width thq-section-max-width">
        <h2 className="logos1-text1 thq-heading-2">
          {props.heading1 ?? (
            <Fragment>
              <span className="logos1-text2">
                Trusted by the world&apos;s best companies to build credibility
              </span>
            </Fragment>
          )}
        </h2>
        <div className="logos1-container2 thq-grid-6">
          <img
            alt={props.imageAlt}
            src={props.imageSrc}
            className="logos1-image1"
          />
          <img
            alt={props.imageAlt1}
            src={props.imageSrc1}
            className="logos1-image2"
          />
          <img
            alt={props.imageAlt2}
            src={props.imageSrc2}
            className="logos1-image3"
          />
        </div>
      </div>
    </div>
  )
}

Logos1.defaultProps = {
  rootClassName: '',
  heading1: undefined,
  imageAlt1: 'image',
  imageAlt: 'image',
  imageSrc1: '/tourlogo-1400w.png',
  imageSrc: '/optimi-workplace-logo-480x816-300w.png',
  imageAlt2: 'image',
  imageSrc2: '/logo1-1400w.png',
}

Logos1.propTypes = {
  rootClassName: PropTypes.string,
  heading1: PropTypes.element,
  imageAlt1: PropTypes.string,
  imageAlt: PropTypes.string,
  imageSrc1: PropTypes.string,
  imageSrc: PropTypes.string,
  imageAlt2: PropTypes.string,
  imageSrc2: PropTypes.string,
}

export default Logos1
